export interface NewsArticle {
  id: string;
  title: string;
  titleHindi: string;
  summary: string;
  summaryHindi: string;
  content?: string;
  image: string;
  imageAlt: string;
  source: string;
  sourceUrl: string;
  publishedAt: string;
  category: string;
  categoryHindi: string;
  district?: string;
  districtHindi?: string;
  isBreaking: boolean;
  isFeatured: boolean;
  isBookmarked?: boolean;
  isSampleData: boolean;
}

export const MOCK_ARTICLES: NewsArticle[] = [
{
  id: 'article-001',
  title: 'CM Hemant Soren Announces New Infrastructure Development Plan for Jharkhand',
  titleHindi: 'मुख्यमंत्री हेमंत सोरेन ने झारखंड के लिए नई इंफ्रास्ट्रक्चर विकास योजना की घोषणा की',
  summary: 'Chief Minister Hemant Soren unveiled a comprehensive ₹12,000 crore infrastructure development plan covering roads, bridges, and rural connectivity across all 24 districts of Jharkhand.',
  summaryHindi: 'मुख्यमंत्री हेमंत सोरेन ने झारखंड के सभी 24 जिलों में सड़क, पुल और ग्रामीण कनेक्टिविटी को कवर करने वाली ₹12,000 करोड़ की व्यापक इंफ्रास्ट्रक्चर विकास योजना का अनावरण किया।',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_14ad05b5e-1768414389952.png",
  imageAlt: 'Government building with Indian flag representing Jharkhand state government announcement',
  source: 'प्रभात खबर',
  sourceUrl: 'https://www.prabhatkhabar.com',
  publishedAt: '2026-09-15T06:30:00Z',
  category: 'politics',
  categoryHindi: 'राजनीति',
  district: 'ranchi',
  districtHindi: 'रांची',
  isBreaking: true,
  isFeatured: true,
  isSampleData: true
},
{
  id: 'article-002',
  title: 'JPSC Combined Civil Services Exam 2026 Dates Announced',
  titleHindi: 'JPSC संयुक्त सिविल सेवा परीक्षा 2026 की तारीखें घोषित',
  summary: 'Jharkhand Public Service Commission has officially announced the examination schedule for the JPSC Combined Civil Services 2026, with the preliminary exam scheduled for November.',
  summaryHindi: 'झारखंड लोक सेवा आयोग ने JPSC संयुक्त सिविल सेवा 2026 की परीक्षा अनुसूची की आधिकारिक घोषणा की है, प्रारंभिक परीक्षा नवंबर में निर्धारित है।',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1216a2b52-1772861739367.png",
  imageAlt: 'Students studying at desk with books representing JPSC civil services examination preparation',
  source: 'दैनिक जागरण',
  sourceUrl: 'https://www.jagran.com',
  publishedAt: '2026-09-15T05:45:00Z',
  category: 'education',
  categoryHindi: 'शिक्षा',
  district: 'ranchi',
  districtHindi: 'रांची',
  isBreaking: true,
  isFeatured: false,
  isSampleData: true
},
{
  id: 'article-003',
  title: 'Dhanbad Coal Mines Safety Review: DGMS Issues New Guidelines',
  titleHindi: 'धनबाद कोयला खदान सुरक्षा समीक्षा: DGMS ने नई दिशानिर्देश जारी किए',
  summary: 'The Directorate General of Mines Safety issued updated safety protocols for all coal mines in Dhanbad following a comprehensive inspection drive conducted last month.',
  summaryHindi: 'खान सुरक्षा महानिदेशालय ने पिछले महीने किए गए व्यापक निरीक्षण के बाद धनबाद की सभी कोयला खदानों के लिए अपडेटेड सुरक्षा प्रोटोकॉल जारी किए।',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_409459f7b-1789459184683.png",
  imageAlt: 'Industrial mining equipment and coal mine infrastructure in Dhanbad Jharkhand',
  source: 'हिंदुस्तान',
  sourceUrl: 'https://www.livehindustan.com',
  publishedAt: '2026-09-15T04:20:00Z',
  category: 'jharkhand',
  categoryHindi: 'झारखंड',
  district: 'dhanbad',
  districtHindi: 'धनबाद',
  isBreaking: false,
  isFeatured: false,
  isSampleData: true
},
{
  id: 'article-004',
  title: 'Tata Steel Jamshedpur Announces 500 New Apprenticeship Vacancies',
  titleHindi: 'टाटा स्टील जमशेदपुर ने 500 नई अप्रेंटिसशिप रिक्तियों की घोषणा की',
  summary: 'Tata Steel Jamshedpur has opened applications for 500 trade apprenticeship positions across various departments, offering monthly stipends and potential absorption into permanent roles.',
  summaryHindi: 'टाटा स्टील जमशेदपुर ने विभिन्न विभागों में 500 ट्रेड अप्रेंटिसशिप पदों के लिए आवेदन खोले हैं, मासिक वजीफा और स्थायी पदों में अवशोषण की संभावना के साथ।',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_4a8074179-1789459182820.png",
  imageAlt: 'Steel factory workers at Tata Steel plant in Jamshedpur Jharkhand industrial area',
  source: 'टेलीग्राफ इंडिया',
  sourceUrl: 'https://www.telegraphindia.com',
  publishedAt: '2026-09-15T03:10:00Z',
  category: 'jobs',
  categoryHindi: 'नौकरी',
  district: 'jamshedpur',
  districtHindi: 'जमशेदपुर',
  isBreaking: false,
  isFeatured: false,
  isSampleData: true
},
{
  id: 'article-005',
  title: 'Ranchi Smart City Project: New Roads and Footpaths Ready in Doranda',
  titleHindi: 'रांची स्मार्ट सिटी प्रोजेक्ट: डोरंडा में नई सड़कें और फुटपाथ तैयार',
  summary: 'The Ranchi Smart City Mission completed the road widening and footpath construction work in Doranda area, improving connectivity for over 50,000 daily commuters.',
  summaryHindi: 'रांची स्मार्ट सिटी मिशन ने डोरंडा क्षेत्र में सड़क चौड़ीकरण और फुटपाथ निर्माण कार्य पूरा किया, 50,000 से अधिक दैनिक यात्रियों की कनेक्टिविटी में सुधार।',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_417a73f18-1789459182467.png",
  imageAlt: 'Urban road construction and smart city infrastructure development in Ranchi Jharkhand',
  source: 'प्रभात खबर',
  sourceUrl: 'https://www.prabhatkhabar.com',
  publishedAt: '2026-09-15T02:00:00Z',
  category: 'ranchi',
  categoryHindi: 'रांची',
  district: 'ranchi',
  districtHindi: 'रांची',
  isBreaking: false,
  isFeatured: false,
  isSampleData: true
},
{
  id: 'article-006',
  title: 'Jharkhand Monsoon 2026: Heavy Rainfall Alert Issued for 12 Districts',
  titleHindi: 'झारखंड मानसून 2026: 12 जिलों में भारी बारिश का अलर्ट जारी',
  summary: 'The India Meteorological Department issued a heavy rainfall warning for 12 Jharkhand districts including Ranchi, Hazaribagh, and Giridih for the next 48 hours.',
  summaryHindi: 'भारत मौसम विज्ञान विभाग ने अगले 48 घंटों के लिए रांची, हजारीबाग और गिरिडीह सहित झारखंड के 12 जिलों के लिए भारी बारिश की चेतावनी जारी की।',
  image: "https://images.unsplash.com/photo-1653728173324-43e4ffcb0418",
  imageAlt: 'Heavy monsoon rain falling on green hills and forests in Jharkhand India',
  source: 'आज तक',
  sourceUrl: 'https://www.aajtak.in',
  publishedAt: '2026-09-14T22:30:00Z',
  category: 'weather',
  categoryHindi: 'मौसम',
  isBreaking: true,
  isFeatured: false,
  isSampleData: true
},
{
  id: 'article-007',
  title: 'Bokaro Steel Plant Achieves Record Production in August 2026',
  titleHindi: 'बोकारो स्टील प्लांट ने अगस्त 2026 में रिकॉर्ड उत्पादन हासिल किया',
  summary: 'Bokaro Steel Plant, a subsidiary of SAIL, achieved its highest ever monthly production of 4.2 lakh tonnes of crude steel in August 2026, surpassing previous records.',
  summaryHindi: 'SAIL की सहायक कंपनी बोकारो स्टील प्लांट ने अगस्त 2026 में 4.2 लाख टन कच्चे स्टील का अपना अब तक का सर्वाधिक मासिक उत्पादन हासिल किया।',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_4ece18378-1789459183507.png",
  imageAlt: 'Steel plant furnace and production facility at Bokaro Steel Plant SAIL in Jharkhand',
  source: 'बिज़नेस स्टैंडर्ड',
  sourceUrl: 'https://www.business-standard.com',
  publishedAt: '2026-09-14T20:15:00Z',
  category: 'jharkhand',
  categoryHindi: 'झारखंड',
  district: 'bokaro',
  districtHindi: 'बोकारो',
  isBreaking: false,
  isFeatured: false,
  isSampleData: true
},
{
  id: 'article-008',
  title: 'Hazaribagh Tourism: New Eco-Trail Inaugurated at Canary Hill',
  titleHindi: 'हजारीबाग पर्यटन: कैनेरी हिल पर नई इको-ट्रेल का उद्घाटन',
  summary: 'The Jharkhand Tourism Department inaugurated a 5-km eco-trail at Canary Hill, Hazaribagh, offering trekking routes through dense forest and panoramic hilltop views.',
  summaryHindi: 'झारखंड पर्यटन विभाग ने हजारीबाग के कैनेरी हिल पर 5 किमी इको-ट्रेल का उद्घाटन किया, घने जंगल और पहाड़ी दृश्यों के माध्यम से ट्रेकिंग मार्ग प्रदान करते हुए।',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_488be040d-1789459182589.png",
  imageAlt: 'Green forested hills and trekking trail at Canary Hill Hazaribagh Jharkhand tourism',
  source: 'दैनिक भास्कर',
  sourceUrl: 'https://www.bhaskar.com',
  publishedAt: '2026-09-14T18:40:00Z',
  category: 'hazaribagh',
  categoryHindi: 'हजारीबाग',
  district: 'hazaribagh',
  districtHindi: 'हजारीबाग',
  isBreaking: false,
  isFeatured: false,
  isSampleData: true
},
{
  id: 'article-009',
  title: 'Giridih: Parasnath Hill Pilgrimage Route Widening Work Begins',
  titleHindi: 'गिरिडीह: पारसनाथ पहाड़ तीर्थ मार्ग चौड़ीकरण कार्य शुरू',
  summary: 'The National Highways Authority of India began the widening of the approach road to Parasnath Hill, the highest peak in Jharkhand and a major Jain pilgrimage site.',
  summaryHindi: 'भारतीय राष्ट्रीय राजमार्ग प्राधिकरण ने पारसनाथ पहाड़ी तक पहुंच सड़क को चौड़ा करने का काम शुरू किया, जो झारखंड की सबसे ऊंची चोटी और एक प्रमुख जैन तीर्थ स्थल है।',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1026b8728-1783596822932.png",
  imageAlt: 'Parasnath hill pilgrimage site in Giridih Jharkhand with mountain landscape and religious temple',
  source: 'प्रभात खबर',
  sourceUrl: 'https://www.prabhatkhabar.com',
  publishedAt: '2026-09-14T16:00:00Z',
  category: 'giridih',
  categoryHindi: 'गिरिडीह',
  district: 'giridih',
  districtHindi: 'गिरिडीह',
  isBreaking: false,
  isFeatured: false,
  isSampleData: true
},
{
  id: 'article-010',
  title: 'Jharkhand Hockey Team Qualifies for National Championship Finals',
  titleHindi: 'झारखंड हॉकी टीम राष्ट्रीय चैंपियनशिप फाइनल के लिए क्वालीफाई',
  summary: 'The Jharkhand state hockey team secured their berth in the National Hockey Championship finals after defeating Odisha 3-2 in a thrilling semifinal match held in Bhubaneswar.',
  summaryHindi: 'झारखंड राज्य हॉकी टीम ने भुवनेश्वर में खेले गए रोमांचक सेमीफाइनल में ओडिशा को 3-2 से हराकर राष्ट्रीय हॉकी चैंपियनशिप फाइनल में जगह बनाई।',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_4e127fbe0-1789459183161.png",
  imageAlt: 'Field hockey players in action during national championship match representing Jharkhand sports',
  source: 'स्पोर्ट्सकीड़ा',
  sourceUrl: 'https://hindi.sportskeeda.com',
  publishedAt: '2026-09-14T14:25:00Z',
  category: 'sports',
  categoryHindi: 'खेल',
  isBreaking: false,
  isFeatured: false,
  isSampleData: true
},
{
  id: 'article-011',
  title: 'Deoghar Baidyanath Dham: Shravani Mela Revenue Crosses ₹200 Crore',
  titleHindi: 'देवघर बैद्यनाथ धाम: श्रावणी मेला राजस्व ₹200 करोड़ के पार',
  summary: 'The annual Shravani Mela at Baidyanath Dham, Deoghar generated over ₹200 crore in revenue this year with an estimated 1.2 crore pilgrims visiting during the month-long fair.',
  summaryHindi: 'देवघर के बैद्यनाथ धाम में वार्षिक श्रावणी मेले ने इस साल ₹200 करोड़ से अधिक राजस्व उत्पन्न किया, एक महीने के मेले के दौरान अनुमानित 1.2 करोड़ श्रद्धालुओं ने दौरा किया।',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1039ccbec-1774978863437.png",
  imageAlt: 'Baidyanath Dham temple in Deoghar Jharkhand during Shravani Mela with pilgrims and devotees',
  source: 'अमर उजाला',
  sourceUrl: 'https://www.amarujala.com',
  publishedAt: '2026-09-14T12:00:00Z',
  category: 'deoghar',
  categoryHindi: 'देवघर',
  district: 'deoghar',
  districtHindi: 'देवघर',
  isBreaking: false,
  isFeatured: false,
  isSampleData: true
},
{
  id: 'article-012',
  title: 'Koderma Mica Mining Area: Rehabilitation Scheme for 8,000 Families',
  titleHindi: 'कोडरमा अभ्रक खनन क्षेत्र: 8,000 परिवारों के लिए पुनर्वास योजना',
  summary: 'The Jharkhand government announced a comprehensive rehabilitation scheme for 8,000 families affected by the decline of mica mining in Koderma, including livelihood support and skill training.',
  summaryHindi: 'झारखंड सरकार ने कोडरमा में अभ्रक खनन में गिरावट से प्रभावित 8,000 परिवारों के लिए आजीविका सहायता और कौशल प्रशिक्षण सहित एक व्यापक पुनर्वास योजना की घोषणा की।',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_42d52bccd-1789459185018.png",
  imageAlt: 'Rural village community in Koderma Jharkhand mica mining region rehabilitation program',
  source: 'हिंदुस्तान',
  sourceUrl: 'https://www.livehindustan.com',
  publishedAt: '2026-09-14T10:30:00Z',
  category: 'koderma',
  categoryHindi: 'कोडरमा',
  district: 'koderma',
  districtHindi: 'कोडरमा',
  isBreaking: false,
  isFeatured: false,
  isSampleData: true
},
{
  id: 'article-013',
  title: 'Jharkhand Police Cracks Down on Cyber Fraud Network: 23 Arrested',
  titleHindi: 'झारखंड पुलिस ने साइबर फ्रॉड नेटवर्क का भंडाफोड़: 23 गिरफ्तार',
  summary: 'Jharkhand Police CID busted a major cyber fraud network operating from Jamtara and Deoghar, arresting 23 individuals who allegedly defrauded victims across 8 states of over ₹3.5 crore.',
  summaryHindi: 'झारखंड पुलिस CID ने जामताड़ा और देवघर से संचालित एक प्रमुख साइबर फ्रॉड नेटवर्क का भंडाफोड़ किया, 23 व्यक्तियों को गिरफ्तार किया जिन्होंने कथित तौर पर 8 राज्यों के पीड़ितों से ₹3.5 करोड़ से अधिक की ठगी की।',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_4f8b5976a-1789459183818.png",
  imageAlt: 'Police investigation and cyber crime unit operation representing Jharkhand cyber fraud arrest',
  source: 'एनडीटीवी इंडिया',
  sourceUrl: 'https://ndtv.in',
  publishedAt: '2026-09-14T09:15:00Z',
  category: 'crime',
  categoryHindi: 'अपराध',
  isBreaking: true,
  isFeatured: false,
  isSampleData: true
},
{
  id: 'article-014',
  title: 'Mukhyamantri Sarthi Yojana: 1.5 Lakh Youth Registered for Free Coaching',
  titleHindi: 'मुख्यमंत्री सारथी योजना: मुफ्त कोचिंग के लिए 1.5 लाख युवाओं ने पंजीकरण कराया',
  summary: 'Over 1.5 lakh youth have registered under the Mukhyamantri Sarthi Yojana for free competitive exam coaching, with the first batch to begin classes at designated centers from October 1.',
  summaryHindi: 'मुख्यमंत्री सारथी योजना के तहत प्रतियोगी परीक्षा की मुफ्त कोचिंग के लिए 1.5 लाख से अधिक युवाओं ने पंजीकरण कराया है, पहले बैच की कक्षाएं 1 अक्टूबर से निर्धारित केंद्रों पर शुरू होंगी।',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_190732256-1772276671210.png",
  imageAlt: 'Young students attending coaching classes for competitive exams under Jharkhand government scheme',
  source: 'दैनिक जागरण',
  sourceUrl: 'https://www.jagran.com',
  publishedAt: '2026-09-14T07:45:00Z',
  category: 'jobs',
  categoryHindi: 'नौकरी',
  district: 'ranchi',
  districtHindi: 'रांची',
  isBreaking: false,
  isFeatured: false,
  isSampleData: true
}];


export const BREAKING_TICKER_ITEMS = [
'मुख्यमंत्री हेमंत सोरेन ने ₹12,000 करोड़ की इंफ्रास्ट्रक्चर योजना घोषित की',
'JPSC संयुक्त सिविल सेवा परीक्षा 2026 की तारीखें जारी — नवंबर में प्रारंभिक परीक्षा',
'झारखंड के 12 जिलों में अगले 48 घंटों के लिए भारी बारिश का अलर्ट',
'जामताड़ा साइबर फ्रॉड: 23 गिरफ्तार, ₹3.5 करोड़ की ठगी का मामला',
'झारखंड हॉकी टीम राष्ट्रीय चैंपियनशिप फाइनल में — ओडिशा को 3-2 से हराया'];


export const CATEGORIES = [
{ id: 'cat-jharkhand', slug: 'jharkhand', labelHindi: 'झारखंड', labelEnglish: 'Jharkhand', emoji: '🏔️', color: '#1D4ED8', bgColor: '#EFF6FF', type: 'state' },
{ id: 'cat-ranchi', slug: 'ranchi', labelHindi: 'रांची', labelEnglish: 'Ranchi', emoji: '🏙️', color: '#0369A1', bgColor: '#F0F9FF', type: 'district' },
{ id: 'cat-koderma', slug: 'koderma', labelHindi: 'कोडरमा', labelEnglish: 'Koderma', emoji: '💎', color: '#7C3AED', bgColor: '#F5F3FF', type: 'district' },
{ id: 'cat-dhanbad', slug: 'dhanbad', labelHindi: 'धनबाद', labelEnglish: 'Dhanbad', emoji: '⛏️', color: '#92400E', bgColor: '#FFFBEB', type: 'district' },
{ id: 'cat-jamshedpur', slug: 'jamshedpur', labelHindi: 'जमशेदपुर', labelEnglish: 'Jamshedpur', emoji: '🏭', color: '#065F46', bgColor: '#ECFDF5', type: 'district' },
{ id: 'cat-bokaro', slug: 'bokaro', labelHindi: 'बोकारो', labelEnglish: 'Bokaro', emoji: '🔩', color: '#1E40AF', bgColor: '#EFF6FF', type: 'district' },
{ id: 'cat-hazaribagh', slug: 'hazaribagh', labelHindi: 'हजारीबाग', labelEnglish: 'Hazaribagh', emoji: '🌿', color: '#166534', bgColor: '#F0FDF4', type: 'district' },
{ id: 'cat-giridih', slug: 'giridih', labelHindi: 'गिरिडीह', labelEnglish: 'Giridih', emoji: '🌄', color: '#9A3412', bgColor: '#FFF7ED', type: 'district' },
{ id: 'cat-deoghar', slug: 'deoghar', labelHindi: 'देवघर', labelEnglish: 'Deoghar', emoji: '🛕', color: '#B45309', bgColor: '#FFFBEB', type: 'district' },
{ id: 'cat-politics', slug: 'politics', labelHindi: 'राजनीति', labelEnglish: 'Politics', emoji: '🏛️', color: '#DC2626', bgColor: '#FEF2F2', type: 'topic' },
{ id: 'cat-education', slug: 'education', labelHindi: 'शिक्षा', labelEnglish: 'Education', emoji: '📚', color: '#0284C7', bgColor: '#F0F9FF', type: 'topic' },
{ id: 'cat-jobs', slug: 'jobs', labelHindi: 'नौकरी', labelEnglish: 'Jobs & Schemes', emoji: '💼', color: '#059669', bgColor: '#ECFDF5', type: 'topic' },
{ id: 'cat-sports', slug: 'sports', labelHindi: 'खेल', labelEnglish: 'Sports', emoji: '⚽', color: '#D97706', bgColor: '#FFFBEB', type: 'topic' },
{ id: 'cat-weather', slug: 'weather', labelHindi: 'मौसम', labelEnglish: 'Weather', emoji: '🌤️', color: '#0369A1', bgColor: '#F0F9FF', type: 'topic' },
{ id: 'cat-crime', slug: 'crime', labelHindi: 'अपराध', labelEnglish: 'Crime', emoji: '🚨', color: '#B91C1C', bgColor: '#FEF2F2', type: 'topic' },
{ id: 'cat-breaking', slug: 'breaking', labelHindi: 'ब्रेकिंग न्यूज़', labelEnglish: 'Breaking News', emoji: '🔴', color: '#CC0000', bgColor: '#FEF2F2', type: 'topic' }];


export function getTimeAgo(publishedAt: string, lang: 'hi' | 'en' = 'hi'): string {
  const now = new Date();
  const published = new Date(publishedAt);
  const diffMs = now.getTime() - published.getTime();
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMins / 60);
  const diffDays = Math.floor(diffHours / 24);

  if (lang === 'hi') {
    if (diffMins < 60) return `${diffMins} मिनट पहले`;
    if (diffHours < 24) return `${diffHours} घंटे पहले`;
    return `${diffDays} दिन पहले`;
  } else { 
    if (diffMins < 60) return `${diffMins} mins ago`;
    if (diffHours < 24) return `${diffHours} hours ago`;
    return `${diffDays} days ago`;
  }
}

export function getCategoryBySlug(slug: string) {
  return CATEGORIES.find((c) => c.slug === slug);
}